import { QuestionnaireUserUploadPhotos } from '@app/questionnaire/components/upload/QuestionnaireUserUploadPhotos';

export const ParentUploadPhotosPage = () => {
  return <QuestionnaireUserUploadPhotos />;
};
